import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import work from '@/view/work'
import about from '@/view/about'
import article from '@/view/article'
import contact from '@/view/contact'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: { name: 'index',transition:"fade" }
    },
    {
      path: '/work',
      name: 'work',
      component: work,
      meta: { name: 'work',transition:"fade" }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: { name: 'about',transition:"fade" }
    },
    {
      path: '/article',
      name: 'article',
      component: article,
      meta: { name: 'article',transition:"fade" }
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta: { name: 'contact',transition:"fade" }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js